
// Basic mobile detection: user agent + viewport
function isMobileDevice() {
  return (
    /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    window.matchMedia("(max-width: 768px)").matches
  );
}

$(function() {
  // ---- GLOBAL HELPERS ----

  // Turn OFF every signup button on the page
  function resetAllButtons() {
    var $allArticles   = $(".article--event");
    var $allWrappers   = $allArticles.find(".button");
    var $allSubmits    = $allArticles.find('input[type="submit"], button[type="submit"]');
    console.log('new one 4');

    $allWrappers.addClass("disabled");
    $allSubmits.removeAttr("formaction");
  }

  // Close all custom dropdowns
  function closeAllSelects() {
    $(".custom-select")
      .removeClass("open")
      .find(".options")
      .stop(true, true)
      .slideUp();
  }

  // Initial hard reset
  resetAllButtons();

  // ---- PER-SELECT LOGIC ----
  $(".custom-select").each(function() {
    var $container = $(this);
    var $native    = $container.find("select.input-select");
    var $face      = $container.find(".selected");
    var $list      = $container.find(".options");

    // Scope buttons to THIS class card
    var $article     = $container.closest(".article--event");
    var $btnWrappers = $article.find(".button");
    var $submits     = $article.find('input[type="submit"], button[type="submit"]');

    // Default label text
    var defaultText =
      ($face.text() || "").trim() ||
      ($native.find("option:selected").text() || "").trim() ||
      "Select an option";

    // Build Shopify add-to-cart URL for a variant id
    function buildCartUrl(id) {
      return id
        ? "https://thelittleartbus.com/cart/add?items[][id]=" +
            encodeURIComponent(id) +
            "&items[][quantity]=1"
        : "";
    }

    // Called whenever a selection changes (native or custom)
    function applySelection(id, text) {
      // Update visible label on this select
      $face.text(text || defaultText);

      // 1) Turn EVERYTHING off
      resetAllButtons();

      // 2) If nothing chosen, we're done
      if (!id) return;

      // 3) Enable ONLY this class's buttons
      var url = buildCartUrl(id);
      $btnWrappers.removeClass("disabled");
      $submits.attr("formaction", url);
    }

    // Switch between native-select mode (mobile) and custom (desktop)
    function setMode(useNative) {
      if (useNative) {
        $container.addClass("use-native").removeClass("open");
        $list.hide();
      } else {
        $container.removeClass("use-native");
        $list.hide();
      }

      // Sync initial selection state
      var $opt = $native.find("option:selected");
      applySelection($opt.val() || "", $opt.text());
    }

    // ---- INIT ----
    setMode(isMobileDevice());

    // Native select change (mobile & fallback)
    $native.on("change", function() {
      var $opt = $native.find("option:selected");
      applySelection($opt.val() || "", $opt.text());
      $container.removeClass("open");
      $list.stop(true, true).slideUp();
    });

    // Click on fake "selected" face (desktop custom)
    $face.on("click", function(e) {
      e.stopPropagation();
      if ($container.hasClass("use-native")) return; // native select is in control
      closeAllSelects();
      $container.toggleClass("open");
      $list.stop(true, true).slideToggle();
    });

    // Click on custom option (desktop)
    $list.on("click", "li", function(e) {
      e.stopPropagation();
      if ($(this).is("[disabled]")) return; // ignore disabled/SOLD OUT items

      var id  = $(this).data("value");
      var txt = $(this).text();

      // Keep native select in sync; triggers applySelection
      $native.val(id).trigger("change");
    });

    // Respond to viewport changes
    var resizeTO;
    $(window).on("resize orientationchange", function() {
      clearTimeout(resizeTO);
      resizeTO = setTimeout(function() {
        setMode(isMobileDevice());
      }, 100);
    });
  });

  // Close dropdowns when clicking outside
  $(document).on("click", function() {
    closeAllSelects();
  });

  // Guard: prevent form submit if no action/formaction
  $("form").on("submit", function(e) {
    var $active = $(document.activeElement);
    if ($active.is('input[type="submit"], button[type="submit"]')) {
      var fa     = $active.attr("formaction");
      var action = $(this).attr("action");
      if (!fa && !action) {
        e.preventDefault();
      }
    }
  });
});